(() => {
  if (customElements.get('announcement-bar')) {
    return;
  }

  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
      this.dropdownCloseButton = this.querySelectorAll('[data-close-button]');
      this.detailsItems = this.querySelectorAll('details');
    }

    connectedCallback() {
      this.initSlider();

      this.attachEvents();
    }

    attachEvents() {
      this.slider.on('transitionEnd', () => {
        this.closeOpenDropdowns();
      });

      window.addEventListener('scroll', () => {
        this.closeOpenDropdowns(true);
      });

      this.dropdownCloseButton.forEach((closeButton) => {
        closeButton.addEventListener('click', () => {
          this.close(closeButton.closest('details'));

          this.toggleDropdownOpenClass(false);
          this.toggleAutoplay(true);
        });
      });

      this.detailsItems.forEach((details) => {
        details.querySelector('summary').addEventListener('click', (event) => {
          if (details.hasAttribute('open')) {
            this.close(details);
            this.toggleAutoplay(true);
            this.toggleDropdownOpenClass(false);
          } else {
            this.open(details);
            this.toggleDropdownOpenClass(true);
            this.toggleAutoplay(false);
          }

          event.preventDefault();
        });
      });
    }

    initSlider() {
      if (!this.querySelector('[data-slider]')) return;

      this.options = {
        slidesPerView: 1,
        loop: true,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
      };

      if (this.hasAttribute('data-autoplay')) {
        this.options.autoplay = {
          delay: this.dataset.autoplaySpeed,
          pauseOnMouseEnter: true,
        };
      }

      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }

    closeOpenDropdowns(closeActiveSlideDropdown = false) {
      let openDropdowns = this.querySelectorAll(
        '.swiper-slide:not(.swiper-slide-active) details[open]',
      );

      if (closeActiveSlideDropdown) {
        openDropdowns = this.querySelectorAll('.swiper-slide details[open]');
      }

      openDropdowns.forEach((dropdown) => {
        dropdown.classList.remove('open');
        this.toggleAnimation(dropdown);
      });
    }

    toggleDropdownOpenClass(add = true) {
      this.classList.toggle('dropdown-open', add);
    }

    toggleAutoplay(start = true) {
      if (!this.hasAttribute('data-autoplay')) return;

      if (start) {
        this.slider.autoplay.start();
      } else {
        this.slider.autoplay.stop();
      }
    }

    open(details) {
      details.classList.add('open');

      details.setAttribute('open', true);
    }

    close(details) {
      details.classList.remove('open');

      this.toggleAnimation(details);
    }

    toggleAnimation(detailsElement, delay = 400) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < delay) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);
})();
